<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailDevis.signature.title') }}
      </p>
    </header>
    <div class="card-content">
      <tab-liste-signature-histo
        :signatures="detailDevisCommande.signaturesHisto">
      </tab-liste-signature-histo>
    </div>
  </div>
</template>

<script>
import tabListeSignatureHisto from '@/components/devisCommandes/detailDevisCommande/tabListeSignatureHisto';

export default {
  props: {
    detailDevisCommande: {
      type: Object,
      required: true,
    },
  },
  components: {
    tabListeSignatureHisto,
  },
};
</script>

<style>

</style>
